import React from 'react'

const Strength = (props) => {
    let { objectiveData, setObjectiveData, setSaveStrengthData, ObjectiveNotesProps, } = { ...props };
    let strength = objectiveData?.Strength;

    const handleStrength = (e) => {
        let { name } = e.target;
        console.log("handleObjectiveFindingobjectiveFindingData", name)
        setObjectiveData(prev => {
        console.log("handleObjectiveFindingobjectiveFindingData123", {
                ...prev,
                'Strength': {
                    ...prev?.Strength,
                    [name]: prev?.Strength?.[name] === "true" ? "false" : "true",
                },
            })
            return ({
                ...prev,
                'Strength': {
                    ...prev?.Strength,
                    [name]: prev?.Strength?.[name] === "true" ? "false" : "true",
                },
            });
        });

        setSaveStrengthData(prev => ({
            ...prev,
            [name]: prev[name] === "true" ? "false" : "true"
        }));
    }

    const handleChangeStrengthText = (e) => {
        let { name, value } = e.target;
        console.log("handleObjectiveFindingobjectiveFindingData", name)
        setObjectiveData(prev => {
        console.log("handleObjectiveFindingobjectiveFindingData123", {
                ...prev,
                'Strength': { ...prev?.Strength, [name]: value },
            })
            return ({
                ...prev,
                'Strength': { ...prev?.Strength, [name]: value },
            });
        });

        setSaveStrengthData(prev => ({ ...prev, [name]: value }));

    }
  return (
    <div className="d-flex flex-column gap-1">
        {/* <p className="heading fs-13 lh-normal">Range of Motion (Strength):</p> */}
        <div className="d-flex gap-40 flex-wrap row-gap-10">
        <div className="d-flex flex-column gap-2">
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_Str_CervicalSpine"
                    checked={strength?.PT_Str_CervicalSpine === "true"}
                    onChange={handleStrength}
                />
            </div>
            <p className="text lh-12">Cervical Spine</p>
            </label>
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_Str_ThoracicLumbarSpine"
                    checked={strength?.PT_Str_ThoracicLumbarSpine === "true"}
                    onChange={handleStrength}
                />
            </div>
            <p className="text lh-12">Thoracic & Lumbar Spine</p>
            </label>
        </div>

        <div className="d-flex flex-column gap-2">
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_Str_Shoulder"
                    checked={strength?.PT_Str_Shoulder === "true"}
                    onChange={handleStrength}
                />
            </div>
            <p className="text lh-12">Shoulder</p>
            </label>
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_Str_Elbow"
                    checked={strength?.PT_Str_Elbow === "true"}
                    onChange={handleStrength}
                />
            </div>
            <p className="text lh-12">Elbow</p>
            </label>
        </div>

        <div className="d-flex flex-column gap-2">
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_Str_Forearm"
                    checked={strength?.PT_Str_Forearm === "true"}
                    onChange={handleStrength}
                />
            </div>
            <p className="text lh-12">Forearm</p>
            </label>
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_Str_Wrist"
                    checked={strength?.PT_Str_Wrist === "true"}
                    onChange={handleStrength}
                />
            </div>
            <p className="text lh-12">Wrist</p>
            </label>
        </div>

        <div className="d-flex flex-column gap-2">
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_Str_Hip"
                    checked={strength?.PT_Str_Hip === "true"}
                    onChange={handleStrength}
                />
            </div>
            <p className="text lh-12">Hip</p>
            </label>
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_Str_Knee"
                    checked={strength?.PT_Str_Knee === "true"}
                    onChange={handleStrength}
                />
            </div>
            <p className="text lh-12">Knee</p>
            </label>
        </div>

        <div className="d-flex flex-column gap-2">
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_Str_Ankle"
                    checked={strength?.PT_Str_Ankle === "true"}
                    onChange={handleStrength}
                />
            </div>
            <p className="text lh-12">Ankle</p>
            </label>
        </div>

        </div>

        {/* Cervical Spine Strength */}
        {strength?.PT_Str_CervicalSpine === "true" ? 
        <div className="d-flex flex-column gap-1">
            <p className="heading">Cervical Spine Strength:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading text-start font-m">Flexion</th>
                    <th className="heading" colSpan={2}>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_CS_Flexion"
                        id="PT_Str_PT_Str_CS_Flexion"
                        value={strength?.PT_Str_CS_Flexion}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Extension</p>
                    </td>
                    <td colSpan={2}>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_CS_Extension"
                        id="PT_Str_CS_Extension"
                        value={strength?.PT_Str_CS_Extension}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Lateral Flexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_CS_LateralFlexionLeft"
                        id="PT_Str_CS_LateralFlexionLeft"
                        value={strength?.PT_Str_CS_LateralFlexionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_CS_LateralFlexionRight"
                        id="PT_Str_CS_LateralFlexionRight"
                        value={strength?.PT_Str_CS_LateralFlexionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Rotation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_CS_RotationLeft"
                        id="PT_Str_CS_RotationLeft"
                        value={strength?.PT_Str_CS_RotationLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_CS_RotationRight"
                        id="PT_Str_CS_RotationRight"
                        value={strength?.PT_Str_CS_RotationRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    name="PT_Str_CS_Notes"
                    id="PT_Str_CS_Notes"
                    autoComplete='off'
                    rows={1}
                    value={strength?.PT_Str_CS_Notes}
                    onChange={handleChangeStrengthText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Thoracic & Lumbar Spine Strength  */}
        {strength?.PT_Str_ThoracicLumbarSpine === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Thoracic & Lumbar Spine Strength:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading text-start font-m">Flexion</th>
                    <th className="heading" colSpan={2}>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_TLS_Flexion"
                        id="PT_Str_TLS_Flexion"
                        value={strength?.PT_Str_TLS_Flexion}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Extension</p>
                    </td>
                    <td colSpan={2}>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_TLS_Extension"
                        id="PT_Str_TLS_Extension"
                        value={strength?.PT_Str_TLS_Extension}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Lateral Flexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_TLS_LateralFlexionLeft"
                        id="PT_Str_TLS_LateralFlexionLeft"
                        value={strength?.PT_Str_TLS_LateralFlexionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_TLS_LateralFlexionRight"
                        id="PT_Str_TLS_LateralFlexionRight"
                        value={strength?.PT_Str_TLS_LateralFlexionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Rotation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_TLS_RotationLeft"
                        id="PT_Str_TLS_RotationLeft"
                        value={strength?.PT_Str_TLS_RotationLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_TLS_RotationRight"
                        id="PT_Str_TLS_RotationRight"
                        value={strength?.PT_Str_TLS_RotationRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_Str_TLS_Notes"
                    id="PT_Str_TLS_Notes"
                    value={strength?.PT_Str_TLS_Notes}
                    onChange={handleChangeStrengthText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Shoulder Strength  */}

        {strength?.PT_Str_Shoulder === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Shoulder Strength:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Flexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Shoulder_FlexionLeft"
                        id="PT_Str_Shoulder_FlexionLeft"
                        value={strength?.PT_Str_Shoulder_FlexionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Shoulder_FlexionRight"
                        id="PT_Str_Shoulder_FlexionRight"
                        value={strength?.PT_Str_Shoulder_FlexionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Extension</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Shoulder_ExtensionLeft"
                        id="PT_Str_Shoulder_ExtensionLeft"
                        value={strength?.PT_Str_Shoulder_ExtensionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Shoulder_ExtensionRight"
                        id="PT_Str_Shoulder_ExtensionRight"
                        value={strength?.PT_Str_Shoulder_ExtensionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Abduction</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Shoulder_AbductionLeft"
                        id="PT_Str_Shoulder_AbductionLeft"
                        value={strength?.PT_Str_Shoulder_AbductionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Shoulder_AbductionRight"
                        id="PT_Str_Shoulder_AbductionRight"
                        value={strength?.PT_Str_Shoulder_AbductionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Adduction</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Shoulder_AdductionLeft"
                        id="PT_Str_Shoulder_AdductionLeft"
                        value={strength?.PT_Str_Shoulder_AdductionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Shoulder_AdductionRight"
                        id="PT_Str_Shoulder_AdductionRight"
                        value={strength?.PT_Str_Shoulder_AdductionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Internal Rotation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Shoulder_InternalRotationLeft"
                        id="PT_Str_Shoulder_InternalRotationLeft"
                        value={strength?.PT_Str_Shoulder_InternalRotationLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Shoulder_InternalRotationRight"
                        id="PT_Str_Shoulder_InternalRotationRight"
                        value={strength?.PT_Str_Shoulder_InternalRotationRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">External Rotation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Shoulder_ExternalRotationLeft"
                        id="PT_Str_Shoulder_ExternalRotationLeft"
                        value={strength?.PT_Str_Shoulder_ExternalRotationLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Shoulder_ExternalRotationRight"
                        id="PT_Str_Shoulder_ExternalRotationRight"
                        value={strength?.PT_Str_Shoulder_ExternalRotationRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_Str_Shoulder_Notes"
                    id="PT_Str_Shoulder_Notes"
                    value={strength?.PT_Str_Shoulder_Notes}
                    onChange={handleChangeStrengthText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Elbow  Strength  */}

        {strength?.PT_Str_Elbow === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Elbow Strength:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Flexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Elbow_FlexionLeft"
                        id="PT_Str_Elbow_FlexionLeft"
                        value={strength?.PT_Str_Elbow_FlexionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Elbow_FlexionRight"
                        id="PT_Str_Elbow_FlexionRight"
                        value={strength?.PT_Str_Elbow_FlexionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Extension</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Elbow_ExtensionLeft"
                        id="PT_Str_Elbow_ExtensionLeft"
                        value={strength?.PT_Str_Elbow_ExtensionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Elbow_ExtensionRight"
                        id="PT_Str_Elbow_ExtensionRight"
                        value={strength?.PT_Str_Elbow_ExtensionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_Str_Elbow_Notes"
                    id="PT_Str_Elbow_Notes"
                    value={strength?.PT_Str_Elbow_Notes}
                    onChange={handleChangeStrengthText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Forearm   Strength  */}

        {strength?.PT_Str_Forearm === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Forearm Strength:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Pronation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Forearm_PronationLeft"
                        id="PT_Str_Forearm_PronationLeft"
                        value={strength?.PT_Str_Forearm_PronationLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Forearm_PronationRight"
                        id="PT_Str_Forearm_PronationRight"
                        value={strength?.PT_Str_Forearm_PronationRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Supination</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Forearm_SupinationLeft"
                        id="PT_Str_Forearm_SupinationLeft"
                        value={strength?.PT_Str_Forearm_SupinationLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Forearm_SupinationRight"
                        id="PT_Str_Forearm_SupinationRight"
                        value={strength?.PT_Str_Forearm_SupinationRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_Str_Forearm_Notes"
                    id="PT_Str_Forearm_Notes"
                    value={strength?.PT_Str_Forearm_Notes}
                    onChange={handleChangeStrengthText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Wrist Strength  */}

        {strength?.PT_Str_Wrist === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Wrist Strength:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Flexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Wrist_FlexionLeft"
                        id="PT_Str_Wrist_FlexionLeft"
                        value={strength?.PT_Str_Wrist_FlexionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Wrist_FlexionRight"
                        id="PT_Str_Wrist_FlexionRight"
                        value={strength?.PT_Str_Wrist_FlexionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Extension</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Wrist_ExtensionLeft"
                        id="PT_Str_Wrist_ExtensionLeft"
                        value={strength?.PT_Str_Wrist_ExtensionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Wrist_ExtensionRight"
                        id="PT_Str_Wrist_ExtensionRight"
                        value={strength?.PT_Str_Wrist_ExtensionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Radial Deviation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Wrist_RadialDeviationLeft"
                        id="PT_Str_Wrist_RadialDeviationLeft"
                        value={strength?.PT_Str_Wrist_RadialDeviationLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Wrist_RadialDeviationRight"
                        id="PT_Str_Wrist_RadialDeviationRight"
                        value={strength?.PT_Str_Wrist_RadialDeviationRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Ulnar Deviation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Wrist_UlnarDeviationLeft"
                        id="PT_Str_Wrist_UlnarDeviationLeft"
                        value={strength?.PT_Str_Wrist_UlnarDeviationLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Wrist_UlnarDeviationRight"
                        id="PT_Str_Wrist_UlnarDeviationRight"
                        value={strength?.PT_Str_Wrist_UlnarDeviationRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_Str_Wrist_Notes"
                    id="PT_Str_Wrist_Notes"
                    value={strength?.PT_Str_Wrist_Notes}
                    onChange={handleChangeStrengthText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Hip Strength  */}

        {strength?.PT_Str_Hip === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Hip Strength:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Flexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Hip_FlexionLeft"
                        id="PT_Str_Hip_FlexionLeft"
                        value={strength?.PT_Str_Hip_FlexionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Hip_FlexionRight"
                        id="PT_Str_Hip_FlexionRight"
                        value={strength?.PT_Str_Hip_FlexionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Extension</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Hip_ExtensionLeft"
                        id="PT_Str_Hip_ExtensionLeft"
                        value={strength?.PT_Str_Hip_ExtensionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Hip_ExtensionRight"
                        id="PT_Str_Hip_ExtensionRight"
                        value={strength?.PT_Str_Hip_ExtensionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Abduction</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Hip_AbductionLeft"
                        id="PT_Str_Hip_AbductionLeft"
                        value={strength?.PT_Str_Hip_AbductionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Hip_AbductionRight"
                        id="PT_Str_Hip_AbductionRight"
                        value={strength?.PT_Str_Hip_AbductionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Adduction</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Hip_AdductionLeft"
                        id="PT_Str_Hip_AdductionLeft"
                        value={strength?.PT_Str_Hip_AdductionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Hip_AdductionRight"
                        id="PT_Str_Hip_AdductionRight"
                        value={strength?.PT_Str_Hip_AdductionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Internal Rotation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Hip_InternalRotationLeft"
                        id="PT_Str_Hip_InternalRotationLeft"
                        value={strength?.PT_Str_Hip_InternalRotationLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Hip_InternalRotationRight"
                        id="PT_Str_Hip_InternalRotationRight"
                        value={strength?.PT_Str_Hip_InternalRotationRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">External Rotation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Hip_ExternalRotationLeft"
                        id="PT_Str_Hip_ExternalRotationLeft"
                        value={strength?.PT_Str_Hip_ExternalRotationLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Hip_ExternalRotationRight"
                        id="PT_Str_Hip_ExternalRotationRight"
                        value={strength?.PT_Str_Hip_ExternalRotationRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_Str_Hip_Notes"
                    id="PT_Str_Hip_Notes"
                    value={strength?.PT_Str_Hip_Notes}
                    onChange={handleChangeStrengthText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Knee    Strength  */}

        {strength?.PT_Str_Knee === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Knee Strength:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Flexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Knee_FlexionLeft"
                        id="PT_Str_Knee_FlexionLeft"
                        value={strength?.PT_Str_Knee_FlexionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Knee_FlexionRight"
                        id="PT_Str_Knee_FlexionRight"
                        value={strength?.PT_Str_Knee_FlexionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Extension</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Knee_ExtensionLeft"
                        id="PT_Str_Knee_ExtensionLeft"
                        value={strength?.PT_Str_Knee_ExtensionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Knee_ExtensionRight"
                        id="PT_Str_Knee_ExtensionRight"
                        value={strength?.PT_Str_Knee_ExtensionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_Str_Knee_Notes"
                    id="PT_Str_Knee_Notes"
                    value={strength?.PT_Str_Knee_Notes}
                    onChange={handleChangeStrengthText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Ankle Strength  */}

        {strength?.PT_Str_Ankle === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Ankle Strength:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Plantarflexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Ankle_PlantarflexionLeft"
                        id="PT_Str_Ankle_PlantarflexionLeft"
                        value={strength?.PT_Str_Ankle_PlantarflexionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Ankle_PlantarflexionRight"
                        id="PT_Str_Ankle_PlantarflexionRight"
                        value={strength?.PT_Str_Ankle_PlantarflexionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Dorsiflexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Ankle_DorsiflexionLeft"
                        id="PT_Str_Ankle_DorsiflexionLeft"
                        value={strength?.PT_Str_Ankle_DorsiflexionLeft}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_Str_Ankle_DorsiflexionRight"
                        id="PT_Str_Ankle_DorsiflexionRight"
                        value={strength?.PT_Str_Ankle_DorsiflexionRight}
                        onChange={handleChangeStrengthText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_Str_Ankle_Notes"
                    id="PT_Str_Ankle_Notes"
                    value={strength?.PT_Str_Ankle_Notes}
                    onChange={handleChangeStrengthText}
                />
                </div>
            </div>
        </div> : <></>}

    </div> 
  )
}

export default Strength